import React from "react";

/**
 * Поле ввода для auth-форм. Подсвечивает ошибку, показывает подсказку.
 */
export default function Field({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  error,
  autoComplete,
  disabled,
  inputMode,
  min,
  max,
}) {
  return (
    <div className="rb-field">
      <label className="rb-field__label" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className={`rb-field__input ${error ? "rb-field__input--error" : ""}`}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        inputMode={inputMode}
        min={min}
        max={max}
      />
      {error && <div className="rb-field__hint">{error}</div>}
    </div>
  );
}
